import { useFlag } from "@/v2/components/feature-flag/FeatureFlagContext";
import { OptionalFieldGroup } from "./FieldGroup";

interface AllowUploadFileBeforeEscalationProps {
  enabled?: boolean;
  onChange: (enabled: boolean) => void;
}

export function AllowUploadFileBeforeEscalation({
  enabled = false,
  onChange,
}: AllowUploadFileBeforeEscalationProps) {
  const isEnabled = useFlag("showAllowUploadFileBeforeEscalation", false);

  if (!isEnabled) {
    return <></>;
  }

  return (
    <OptionalFieldGroup
      label={"Allow Upload File Before Escalation"}
      description={
        "Allow users to upload files before escalating to a live agent."
      }
      enabled={enabled ?? false}
      toggleEnabled={onChange}
    />
  );
}
